module.exports = __webpack_public_path__ + "img/down_android_online.c8760a9d.png";